// Used to handle current state of API in switch
export const apiState = {
    LOADING: "LOADING",
    ERROR: "ERROR",
    SUCCESS: "SUCCESS",
    NO_DATA: "NO_DATA"
}